// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-help-indexstyleGrid-container-bqfmr{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-help-indexstyleGrid-grid-bqxqn{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-help-indexstyleGrid-col6-bhgjt{grid-column:span 6}.pages-help-indexstyleGrid-col3-bphya{grid-column:span 3}.pages-help-indexstyleGrid-col4-bqkiy{grid-column:span 4}.pages-help-indexstyleGrid-col9-canjd{grid-column:span 9}.pages-help-indexstyleGrid-col12-jeqfs{grid-column:span 12}.pages-help-indexstyleGrid-alignItemsStart-brvkt{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-help-indexstyleGrid-container-bqfmr",
	"grid": "pages-help-indexstyleGrid-grid-bqxqn",
	"col6": "pages-help-indexstyleGrid-col6-bhgjt",
	"col3": "pages-help-indexstyleGrid-col3-bphya",
	"col4": "pages-help-indexstyleGrid-col4-bqkiy",
	"col9": "pages-help-indexstyleGrid-col9-canjd",
	"col12": "pages-help-indexstyleGrid-col12-jeqfs",
	"alignItemsStart": "pages-help-indexstyleGrid-alignItemsStart-brvkt"
};
module.exports = ___CSS_LOADER_EXPORT___;
